<script>
import { getMoneySymbolByInvestmentType } from '@modules/consolidator/utils/InvestmentType/InvestmentType.js'
import { filterChartToConsolidatedOnly } from '@modules/consolidator/utils/format-rentability-chart/format-rentability-chart'
import ViewModeToggle from '@modules/consolidator/components/view-mode-toggle/view-mode-toggle.vue'
import SectionTitle from '@components/section-title'
import RentabilidadeChart from '@modules/consolidator/components/rentabilidade-chart/rentabilidade-chart.vue'
import PatrimonioChart from '@modules/consolidator/components/patrimonio-chart/patrimonio-chart.vue'
import PortfolioBenchmark from '@modules/consolidator/components/portfolio-benchmark/portfolio-benchmark.vue'
import EvolucaoPatrimonial from '@modules/consolidator/components/evolucao-patrimonial/evolucao-patrimonial.vue'

export default {
  name: 'Evolucao',
  components: {
    ViewModeToggle,
    SectionTitle,
    RentabilidadeChart,
    PatrimonioChart,
    PortfolioBenchmark,
    EvolucaoPatrimonial,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    hasAssetsAutomatic: {
      type: Boolean,
      default: false,
    },
    dataRentabilidade: {
      type: Object,
      default: () => ({}),
    },
    dataPatrimonio: {
      type: Object,
      default: () => ({}),
    },
    investmentType: {
      type: String,
      default: '',
    },
    benchmarksSelecionados: {
      type: Array,
      default: () => [],
    },
    benchmarks: {
      type: Array,
      default: () => [],
    },
    clienteBenchmarkMeta: {
      type: Object,
      default: null,
    },
    availableBenchmarkNames: {
      type: Set,
      default: () => new Set(),
    },
    showAddBenchmark: {
      type: Boolean,
      default: false,
    },
    hideBenchmarks: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modoGrafico: 'rentabilidade',
      showAllGroups: false,
    }
  },
  computed: {
    toggleOptions() {
      return [
        { value: 'rentabilidade', title: '%', icon: 'mdi-chart-timeline-variant' },
        { value: 'patrimonio', title: this.moneySymbol, icon: 'mdi-chart-bar' },
      ]
    },
    moneySymbol() {
      return getMoneySymbolByInvestmentType({
        investmentType: this.investmentType,
      })
    },
    displayedRentabilidade() {
      if (!this.dataRentabilidade) return this.dataRentabilidade
      if (this.showAllGroups) return this.dataRentabilidade
      return filterChartToConsolidatedOnly(this.dataRentabilidade)
    },
  },
}
</script>

<template>
  <div class="evolucao">
    <PortfolioBenchmark
      v-if="modoGrafico === 'rentabilidade'"
      :data="dataRentabilidade"
      :loading="loading"
      :has-assets-automatic="hasAssetsAutomatic"
      :value="benchmarksSelecionados"
      :benchmarks="benchmarks"
      :cliente-benchmark-meta="clienteBenchmarkMeta"
      :available-benchmark-names="availableBenchmarkNames"
      :show-add-benchmark="showAddBenchmark"
      :hide-benchmarks="hideBenchmarks"
      @input="$emit('update:benchmarks-selecionados', $event)"
      @change="$emit('change')"
      @add-benchmark="$emit('add-benchmark')"
      @reset="$emit('reset')"
      @update:showAllGroups="showAllGroups = $event"
    >
      <template v-slot:actions-left>
        <ViewModeToggle
          v-model="modoGrafico"
          :options="toggleOptions"
          :disabled="loading"
        />

        <v-tooltip
          v-if="hasAssetsAutomatic"
          class="evolucao__assets-automatic"
          bottom
          max-width="360"
        >
          <template v-slot:activator="{ on, attrs }">
            <icon-svg
              name="mdi-information"
              :size="12"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>
            A rentabilidade do portfólio XP é calculada automaticamente.
            <br />
            Para ver a rentabilidade de cada produto, adicione as informações
            faltantes e os aportes/resgates dele.
          </span>
        </v-tooltip>
      </template>

      <template v-slot:actions-right>
        <div class="evolucao__ampliar">
          <BaseModal max-width="95%" destroy-on-close>
            <template v-slot:button>
              <BaseButton :disabled="loading" secondary text sm>
                <icon-svg name="mdi-fullscreen" :size="16" color="primary" />
                Ampliar
              </BaseButton>
            </template>
            <div>
              <SectionTitle title="Portfólio e Benchmark" />
              <RentabilidadeChart
                :data="displayedRentabilidade"
                class="evolucao__ampliar-chat"
              />
            </div>
          </BaseModal>
        </div>
      </template>
    </PortfolioBenchmark>

    <EvolucaoPatrimonial
      v-if="modoGrafico === 'patrimonio'"
      :data="dataPatrimonio"
      :loading="loading"
      :investment-type="investmentType"
    >
      <template v-slot:actions-left>
        <ViewModeToggle
          v-model="modoGrafico"
          :options="toggleOptions"
          :disabled="loading"
        />
      </template>

      <template v-slot:actions-right>
        <div class="evolucao__ampliar">
          <BaseModal max-width="95%" destroy-on-close>
            <template v-slot:button>
              <BaseButton :disabled="loading" secondary text sm>
                <icon-svg name="mdi-fullscreen" :size="16" color="primary" />
                Ampliar
              </BaseButton>
            </template>
            <div>
              <SectionTitle title="Evolução Patrimonial" />
              <PatrimonioChart
                :data="dataPatrimonio"
                :investmentType="investmentType"
                class="evolucao__ampliar-chat"
              />
            </div>
          </BaseModal>
        </div>
      </template>
    </EvolucaoPatrimonial>
  </div>
</template>

<style lang="sass">
.evolucao
  &__ampliar
    button
      min-width: unset !important

    &-chat
      canvas
        height: 75vh
        width: 100%
</style>
